import { createSlice } from '@reduxjs/toolkit';
import { STATE_NAMES } from './StateNames';
import { DEFAULT_PAGINATION_LIMITS } from '../../components/dashboard/components/ProjectsTab/constants';

export enum PROJECT_LIST {
  PROJECT_ITEM_LIST = 'projectItemList',
  PROJECTS_FOR_SELECT = 'projectsForSelect',
  URL = 'url', // ToDo: remove dependencies
  CURRENT_PAGE = 'current_page',
  TOTAL = 'total',
  PER_PAGE = 'per_page',
  LAST_PAGE = 'last_page',
}

const ProjectListSlice = createSlice({
  name: STATE_NAMES.PROJECT_LIST,
  initialState: {
    [PROJECT_LIST.PROJECT_ITEM_LIST]: [],
    [PROJECT_LIST.PROJECTS_FOR_SELECT]: [],
    [PROJECT_LIST.URL]: '', // ToDo: remove dependencies
    [PROJECT_LIST.CURRENT_PAGE]: 1,
    [PROJECT_LIST.PER_PAGE]: DEFAULT_PAGINATION_LIMITS.DEFAULT,
    [PROJECT_LIST.TOTAL]: null,
    [PROJECT_LIST.LAST_PAGE]: null,
  },
  reducers: {
    setProjects: (state, action) => {
      state[PROJECT_LIST.PROJECT_ITEM_LIST] = action.payload.data;
      state[PROJECT_LIST.LAST_PAGE] = action.payload.last_page;
      state[PROJECT_LIST.URL] = action.payload.url; // ToDo: remove dependencies
      state[PROJECT_LIST.CURRENT_PAGE] = action.payload.current_page;
      state[PROJECT_LIST.TOTAL] = action.payload.total;
      state[PROJECT_LIST.PER_PAGE] = action.payload.per_page;
      state[PROJECT_LIST.LAST_PAGE] = action.payload.last_page;
    },
  },
  selectors: {
    getCurrentPage: state => state[PROJECT_LIST.CURRENT_PAGE],
  },
});

export const { setProjects } = ProjectListSlice.actions;
export const { getCurrentPage } = ProjectListSlice.selectors;

export default ProjectListSlice.reducer;
